import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";

const CLIENT_ID =
    "27064908213-sar1c6pb49flaf563qregab02ndshqfa.apps.googleusercontent.com"; // Replace with your OAuth Client ID

const CLIENT_SECRET = "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";
const API_KEY = "AIzaSyAbgB90PHtmcsRuYibqmir30qt70zR6kG0"; // Replace with your YouTube API Key

const REDIRECT_URI = "http://localhost:3000";

const Youtubeapi = () => {
    const user  = useSelector((state) => state.auth.authData.user);
    const [token, setToken] = useState(null);
    const [refreshToken, setRefreshToken] = useState(null);
    const [channelData, setChannelData] = useState(null);

    useEffect(() => {
        const storedToken = localStorage.getItem("yt_token");
        const storedRefreshToken = localStorage.getItem("yt_refresh_token");

        if (storedToken) {
            setToken(storedToken);
            fetchAllData(storedToken);
        }

        if (storedRefreshToken) {
            setRefreshToken(storedRefreshToken);
        }
    }, []);

    const login = () => {
        const codeClient = window.google.accounts.oauth2.initCodeClient({
          client_id: CLIENT_ID,
          scope: 'https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics.readonly',
          redirect_uri: REDIRECT_URI,
          prompt: 'consent',
          access_type: 'offline',
          callback: (response) => {
            if (response.code) {
              // Send this code to your backend to exchange for access/refresh tokens
              console.log('Authorization Code:', response.code);
              // Example POST to backend
              axios.post("http://localhost:4000/api/youtube/google", {
                code: response.code,
                userId: user._id,
              })
                .then((res) => {
                  const data = res.data;
                  console.log("Access Token:", data.access_token);
                  console.log("Refresh Token:", data.refresh_token);
                  setToken(data.access_token);
                  setRefreshToken(data.refresh_token);
                  fetchAllData(data.access_token);
                })
                .catch((error) => {
                  console.error("Error exchanging code for tokens:", error);
                });
            }
          },
        });
      
        codeClient.requestCode();
      };

    const refreshAccessToken = async () => {
        try {
            const response = await axios.post(
                "https://oauth2.googleapis.com/token",
                {
                    client_id: CLIENT_ID,
                    client_secret: CLIENT_SECRET,
                    refresh_token: refreshToken,
                    grant_type: "refresh_token",
                }
            );

            const newAccessToken = response.data.access_token;
            setToken(newAccessToken);
            localStorage.setItem("yt_token", newAccessToken);
            console.log("New Access Token:", newAccessToken);

            fetchAllData(newAccessToken);
        } catch (error) {
            console.error("Error refreshing access token:", error);
        }
    };

    const fetchAllData = async (accessToken) => {
        await fetchChannelData(accessToken);
    };

    const fetchChannelData = async (accessToken) => {
        try {
            const response = await axios.get(
                "https://www.googleapis.com/youtube/v3/channels",
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                    params: { part: "snippet,statistics", mine: true },
                }
            );
            console.log("Channel Data:", response.data.items[0]);
            setChannelData(response.data.items[0]);
        } catch (error) {
            console.error("Error fetching channel data:", error);
        }
    };

    return (
        <div className="h-screen w-full bg-gray-100 flex flex-col items-center justify-center">
            <h1>Hello This is Prahlad Gaur</h1>

            <button
                onClick={login}
                className="px-4 py-2 bg-blue-500 text-white text-center rounded-md"
            >
                Login with Google
            </button>

            <button
                onClick={refreshAccessToken}
                className="px-4 py-2 bg-green-500 text-white text-center rounded-md mt-4"
            >
                Refresh Access Token
            </button>
        </div>
    );
};

export default Youtubeapi;
